import React from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import Admin from '../components/Admin';
import Layout from '../components/Layout';
import AddToCart from '../components/Layout/Main/AddToCart';
import ProductDetails from '../components/Layout/Main/ProductLists/ProductListItems/ProductDetails';
import ForgotPassword from '../components/Register/ForgotPassword';
import configureStore, { history } from '../store'
import AboutUs from '../components/Layout/AboutUs';
import Login from '../components/Register/Login';
import NavigationBar from '../components/Layout/NavigationBar';
import Footer from '../components/Layout/Footer';
import UserProfile from '../components/Layout/Main/UserProfile';
import Signup from '../components/Register/Signup';
import Checkout from '../components/Layout/Main/Checkout';

const MainRoutes = (props: any) => {
  const store = configureStore()
  return (
	<Provider store={store}>
		<Router history={history}>
			<div className="App">
				<Route component={NavigationBar} />
				<Switch>
					<Route path="/" exact component={Layout} />
					<Route path="/products/:category?/:subcategory?" component={Layout} />
					<Route path="/signin" component={Login} />
					<Route path="/signup" component={Signup} />
					<Route path="/profile" component={UserProfile} />
					<Route path="/forgot-password" exact component={ForgotPassword} />
					<Route path="/admin/:section" component={Admin} />
					<Route path="/productDetails/:productId" component={ProductDetails} />
					<Route path="/cartItems" component={AddToCart} />
					<Route path="/checkout" component={Checkout} />
					<Route path="/aboutus" component={AboutUs} />
				</Switch>
				<Route component={Footer} />
			</div>
		</Router>
	</Provider>
  )
}

export default MainRoutes;
